import React from 'react'
import { getCurrency } from 'utils/currency'
import { FormattedNumber } from 'react-intl'

function FormattedCurrency(props) {
  const {
    value
  } = props

  return (
    <FormattedNumber
      minimumFractionDigits={2}
      maximumFractionDigits={2}
      value={value}
      style='currency'
      currency={getCurrency()}
    />
  )
}

export default FormattedCurrency
